export default __webpack_public_path__ + "static/media/meatgrinder.0e0beea3.png";